import { useCallback, useMemo, useState } from 'react';

export default function useDataRoomDesktopNavigation(dataRoomName: string) {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const shortenedName = useMemo(() => {
    const fls = dataRoomName
      .replace(/[^a-zA-Z0-9 ]/g, '')
      .split(' ')
      .map((word) => word.charAt(0));
    const flCs = fls.filter((letter) => letter === letter.toUpperCase());

    return (flCs.length ? flCs : fls).join('');
  }, [dataRoomName]);

  const setIsCollapsedCallback = useCallback(
    (isCollapsed: boolean) => setIsCollapsed(isCollapsed),
    [],
  );

  return { isCollapsed, shortenedName, setIsCollapsed, setIsCollapsedCallback };
}
